import { render } from "./TheTitle.vue?vue&type=template&id=2fa62f74"
import script from "./TheTitle.vue?vue&type=script&lang=js"
export * from "./TheTitle.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__